import TeamLightbox from './team-lightbox';

export default class TeamCard {
	constructor(root) {
		this.root = root;
		this.id = root?.getAttribute('data-id');
		this.overviewParent = root?.closest('.overview-team');

		if (!this.overviewParent) {
			return;
		}

		this.overviewId = this.overviewParent.getAttribute('data-id');

		const lightbox = document.querySelector(`.team-lightbox[data-id="${this.overviewId}"]`);

		if (lightbox) {
			this.lightbox = new TeamLightbox(lightbox);
		}

		root?.addEventListener('click', (e) => {
			if (e.target !== lightbox && !lightbox.contains(e.target) && !this.root.classList.contains('card-static')) {
				this.lightbox.open(this.id);
			}
		});
	}
}
